import React, { Component } from "react";
import { connect } from "react-redux";
import { updateFilters, updateTypes } from "../../store/actions/siteActions";

class Filters extends Component {
  constructor() {
    super();
    this.state = {
      poseFilter: {
        levels: [],
        types: []
      }
    };
  }

  componentDidMount = () => {
    var elems = document.querySelectorAll('.modal');
    window.M.Modal.init(elems, {});
  }

  static getDerivedStateFromProps = (props, state) => {
    if (!state.loaded) {
      return {
        poseFilter: props.poseFilter,
        loaded: true
      };
    }
    return null;
  };

  handleChange = e => {
    if (e.target.id.startsWith("level")) {
      let levels = this.state.poseFilter.levels;
      if (e.target.checked) {
        levels.push(e.target.name);
      } else {
        levels = levels.filter(l => l !== e.target.name);
      }
      this.setState({
        poseFilter: {
          ...this.state.poseFilter,
          levels: levels
        }
      });
    } else if (e.target.id.startsWith("type")) {
      let types = this.state.poseFilter.types;
      if (e.target.checked) {
        types.push(e.target.name);
      } else {
        types = types.filter(t => t !== e.target.name)
      }
      this.setState({
        poseFilter: {
          ...this.state.poseFilter,
          types: types
        }
      })
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.updateFilters(this.state.poseFilter.levels);
    this.props.updateTypes(this.state.poseFilter.types)
  };

  render() {
    return (
      <div className="row fixed-action-btn">
        <a
          className="waves-effect waves-light btn-floating btn-large modal-trigger"
          href="#modal1"
        >
          <i className="fas fa-dice black" />
        </a>

        <div id="modal1" className="modal">
          <div className="modal-content">

            <form action="#" onSubmit={this.handleSubmit}>
            <div className="row">
              <div className="col s6">
                <h5>Exclude</h5>
              <p>
                <label>
                  <input
                    type="checkbox"
                    id="typeBackbend"
                    name="Backbend"
                    onChange={this.handleChange}
                    checked={this.state.poseFilter.types.includes("Backbend")}
                  />
                  <span>Backbend</span>
                </label>
              </p>
              <p>
                <label>
                  <input
                    type="checkbox"
                    id="typeStanding"
                    name="Standing"
                    onChange={this.handleChange}
                    checked={this.state.poseFilter.types.includes(
                      "Standing"
                    )}
                  />
                  <span>Standing</span>
                </label>
              </p>
              <p>
                <label>
                  <input
                    type="checkbox"
                    id="typeRestorative"
                    name="Restorative"
                    onChange={this.handleChange}
                    checked={this.state.poseFilter.types.includes("Restorative")}
                  />
                  <span>Restorative</span>
                </label>
              </p>
              <p>
                <label>
                  <input
                    type="checkbox"
                    id="typeBalance"
                    name="Balance"
                    onChange={this.handleChange}
                    checked={this.state.poseFilter.types.includes("Balance")}
                  />
                  <span>Balance</span>
                </label>
              </p>
              <p>
                <label>
                  <input
                    type="checkbox"
                    id="typeChestOpening"
                    name="Chest Opening"
                    onChange={this.handleChange}
                    checked={this.state.poseFilter.types.includes("Chest Opening")}
                  />
                  <span>Chest Opening</span>
                </label>
              </p>
              <p>
                <label>
                  <input
                    type="checkbox"
                    id="typeCore"
                    name="Core"
                    onChange={this.handleChange}
                    checked={this.state.poseFilter.types.includes("Core")}
                  />
                  <span>Core</span>
                </label>
              </p>
              </div>
              <div className="col s6">
                <h5>Difficulty</h5>
                <p>
                <label>
                  <input
                    type="checkbox"
                    id="levelBeginner"
                    name="Beginner"
                    onChange={this.handleChange}
                    checked={this.state.poseFilter.levels.includes("Beginner")}
                  />
                  <span>Beginner</span>
                </label>
              </p>
              <p>
                <label>
                  <input
                    type="checkbox"
                    id="levelIntermediate"
                    name="Intermediate"
                    onChange={this.handleChange}
                    checked={this.state.poseFilter.levels.includes(
                      "Intermediate"
                    )}
                  />
                  <span>Intermediate</span>
                </label>
              </p>
              <p>
                <label>
                  <input
                    type="checkbox"
                    id="levelAdvanced"
                    name="Advanced"
                    onChange={this.handleChange}
                    checked={this.state.poseFilter.levels.includes("Advanced")}
                  />
                  <span>Advanced</span>
                </label>
              </p>
              </div>
          </div>
            </form>
          </div>
          <div className="modal-footer">
            <button
              onClick={this.handleSubmit}
              className="modal-close waves-effect waves-green btn-flat button-modal"
            >
              Roll
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    poseFilter: state.site.poseFilter
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateFilters: levels => dispatch(updateFilters(levels)),
    updateTypes : types => dispatch(updateTypes(types))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filters);
